import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f55767c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-ai-center p-px-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Displays", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "p-d-flex p-flex-wrap"
}
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_DisplayItem = _resolveComponent("DisplayItem")!
  const _component_EditDisplayDialog = _resolveComponent("EditDisplayDialog")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "controller-card" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_Button, {
          label: "Scan display",
          icon: "pi pi-camera",
          disabled: !_ctx.account_id,
          style: {"height":"0%"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.commit('setCameraScanMode', true)))
        }, null, 8, ["disabled"])
      ])
    ]),
    content: _withCtx(() => [
      (!_ctx.displays_loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Connect an account to load your displays"))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displays, (display) => {
              return (_openBlock(), _createBlock(_component_DisplayItem, {
                key: display.id,
                name: display.entity.name,
                token_id: display.entity.token_id,
                asset_contract_address: display.entity.asset_contract_address,
                onEditDisplay: ($event: any) => (_ctx.editDisplay(display.id))
              }, null, 8, ["name", "token_id", "asset_contract_address", "onEditDisplay"]))
            }), 128))
          ])),
      (_ctx.displays_loaded && _ctx.displays.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No displays found"))
        : _createCommentVNode("", true),
      (_ctx.account_id)
        ? (_openBlock(), _createBlock(_component_EditDisplayDialog, {
            key: 3,
            createDisplay: _ctx.createDisplay,
            account_id: _ctx.account_id,
            display_id: _ctx.edit_display_id,
            "onUpdate:display_id": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.edit_display_id) = $event))
          }, null, 8, ["createDisplay", "account_id", "display_id"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}